import API from '@aws-amplify/api';
import { Storage } from 'aws-amplify';
import { atom } from 'recoil';

import { getUserById } from '@/service/userService';
import localStorageUtil from '@/common/utils/localStorageUtil';
import Utils from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';
import { getUserListByProjectSelector, getUserPermissionToViewKnowledgeSelector } from '../selector/userSelector';
import { signOut } from '@/service/authenService';



/**
 * Create store save user detail state
 */
export const userAtom = atom({
    key: 'userAtom',
    default: {},
    effects: [
        async ({ setSelf, onSet, trigger, getPromise, getLoadable }) => {
            let userId = localStorageUtil.getUserDetailId();
            if (!Utils.isEmptyString(userId)) {
                try {
                    let userDetail = await getUserById(API, userId);
                    if (Utils.isEmptyObject(userDetail) || userDetail.active === Constant.ACTIVE_FLAG.DELETED) {
                        return signOut();
                    }
                    if(userDetail?.image){
                        userDetail.avatar = await Storage.get(userDetail?.image);
                    }else{
                        userDetail.avatar = Constant.AVATAR_DEFAULT
                    }
                    setSelf({...userDetail});
                } catch (err) {
                    console.error(`atom get user detail error: ${err}`);
                    // return default
                    setSelf({});
                }
            }
        }
    ]
});

export const getUserListByProjectAtom = atom({
    key: 'getUserListByProjectAtom',
    default: getUserListByProjectSelector
});

export const userPermissionToViewKnowledgeAtom = atom({
    key: 'userPermissionToViewKnowledgeAtom',
    default: getUserPermissionToViewKnowledgeSelector
});
